interface ToggleProps {
  checked: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "md";
}

export default function Toggle({ checked, onChange, disabled = false, size = "md" }: ToggleProps) {
  const dims = size === "sm" ? "h-5 w-9" : "h-6 w-11";
  const knob = size === "sm" ? "h-4 w-4" : "h-5 w-5";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!checked)}
      className={`${dims} shrink-0 rounded-full transition-colors duration-200 ${
        disabled
          ? "cursor-not-allowed opacity-40"
          : "cursor-pointer"
      } ${checked ? "bg-[#00AAB7]" : "bg-[#D5EAEA]"}`}
    >
      <span
        className={`${knob} m-0.5 block rounded-full bg-white shadow-sm transition-transform duration-200 ${
          checked ? "-translate-x-[calc(100%+2px)]" : "translate-x-0"
        }`}
      />
    </button>
  );
}